import { render, staticRenderFns } from "./mechanical-desk.vue?vue&type=template&id=3b24e272&scoped=true&"
import script from "./mechanical-desk.vue?vue&type=script&lang=js&"
export * from "./mechanical-desk.vue?vue&type=script&lang=js&"
import style0 from "./mechanical-desk.vue?vue&type=style&index=0&id=3b24e272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24e272",
  null
  
)

export default component.exports